import React from 'react';
// core
import { TextField } from '@material-ui/core';

import { VIEW_MODE } from '../../../utils/const/taskModes';

import useStyles from '../styles';
import QuestionShell from '../QuestionShell';
import useQuestionForm from '../QuestionShell/useQuestionForm';

function DateAnswer({
  identifier, pages, info, handleDeleteQuestion, handleDuplicateQuestion,
  mode, setPages,
}) {
  const styles = useStyles();

  const question = useQuestionForm({
    identifier,
    pages,
    info,
    setPages,
    writeVia: 'setPages',
  });

  return (
    <QuestionShell
      {...question}
      identifier={identifier}
      info={info}
      mode={mode}
      titleKey="task.taskEdition.dateAnswerText.question"
      descriptionKey="task.taskEdition.dateAnswerText.description"
      handleDeleteQuestion={handleDeleteQuestion}
      handleDuplicateQuestion={handleDuplicateQuestion}
    >
      <TextField
        id="date"
        type="date"
        className={styles.textField}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={mode === VIEW_MODE}
      />
    </QuestionShell>
  );
}

export default DateAnswer;
